/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import {
    useInfiniteQuery,
    useMutation,
    useQuery,
    useSuspenseQuery,
} from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseInfiniteQueryResult,
    DefinedUseQueryResult,
    InfiniteData,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    BulkArchiveControlResultsData,
    BulkDownloadControlResultAttachmentsErrorPayload,
    BulkDownloadControlResultAttachmentsParams,
    BulkUnarchiveControlResultsData,
    ControlResultId,
    ControlResultMetadata,
    ExistingControlResultPaginatedListDto,
    ExportControlResultsParams,
    ExtendControlResultsDueDateData,
    FutureControlResultPaginatedListDto,
    GetControlResultsParams,
    GetFutureControlResultsParams,
    ReassignIds,
    RemindIds,
    ReopenIds,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const postControlResultsControlResultIdAnalyticsSeen = (
    controlResultId: ControlResultId,
    controlResultMetadata: ControlResultMetadata,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(
        `/api/control-results/${controlResultId}/analytics/seen`,
        controlResultMetadata,
        options
    );
};

export const getPostControlResultsControlResultIdAnalyticsSeenMutationOptions =
    <TError = AxiosError<null>, TContext = unknown>(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postControlResultsControlResultIdAnalyticsSeen
                >
            >,
            TError,
            { controlResultId: ControlResultId; data: ControlResultMetadata },
            TContext
        >;
        axios?: AxiosRequestConfig;
    }): UseMutationOptions<
        Awaited<
            ReturnType<typeof postControlResultsControlResultIdAnalyticsSeen>
        >,
        TError,
        { controlResultId: ControlResultId; data: ControlResultMetadata },
        TContext
    > => {
        const mutationKey = ["postControlResultsControlResultIdAnalyticsSeen"];
        const { mutation: mutationOptions, axios: axiosOptions } = options
            ? options.mutation &&
              "mutationKey" in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, axios: undefined };

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postControlResultsControlResultIdAnalyticsSeen
                >
            >,
            { controlResultId: ControlResultId; data: ControlResultMetadata }
        > = (props) => {
            const { controlResultId, data } = props ?? {};

            return postControlResultsControlResultIdAnalyticsSeen(
                controlResultId,
                data,
                axiosOptions
            );
        };

        return { mutationFn, ...mutationOptions };
    };

export type PostControlResultsControlResultIdAnalyticsSeenMutationResult =
    NonNullable<
        Awaited<
            ReturnType<typeof postControlResultsControlResultIdAnalyticsSeen>
        >
    >;
export type PostControlResultsControlResultIdAnalyticsSeenMutationBody =
    ControlResultMetadata;
export type PostControlResultsControlResultIdAnalyticsSeenMutationError =
    AxiosError<null>;

export const usePostControlResultsControlResultIdAnalyticsSeen = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postControlResultsControlResultIdAnalyticsSeen
                >
            >,
            TError,
            { controlResultId: ControlResultId; data: ControlResultMetadata },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlResultsControlResultIdAnalyticsSeen>>,
    TError,
    { controlResultId: ControlResultId; data: ControlResultMetadata },
    TContext
> => {
    return useMutation(
        getPostControlResultsControlResultIdAnalyticsSeenMutationOptions(
            options
        ),
        queryClient
    );
};
export const getControlResults = (
    params?: GetControlResultsParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ExistingControlResultPaginatedListDto>> => {
    return axios.get(`/api/control-results`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetControlResultsInfiniteQueryKey = (
    params?: GetControlResultsParams
) => {
    return [
        "infinite",
        `/api/control-results`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetControlResultsQueryKey = (
    params?: GetControlResultsParams
) => {
    return [`/api/control-results`, ...(params ? [params] : [])] as const;
};

export const getGetControlResultsInfiniteQueryOptions = <
    TData = InfiniteData<
        Awaited<ReturnType<typeof getControlResults>>,
        GetControlResultsParams["cursor"]
    >,
    TError = AxiosError<null>,
>(
    params?: GetControlResultsParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getControlResults>>,
                QueryKey,
                GetControlResultsParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetControlResultsInfiniteQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlResults>>,
        QueryKey,
        GetControlResultsParams["cursor"]
    > = ({ signal, pageParam }) =>
        getControlResults(
            { ...params, cursor: pageParam ?? params?.["cursor"] },
            { signal, ...axiosOptions }
        );

    return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getControlResults>>,
        TError,
        TData,
        Awaited<ReturnType<typeof getControlResults>>,
        QueryKey,
        GetControlResultsParams["cursor"]
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlResultsInfiniteQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlResults>>
>;
export type GetControlResultsInfiniteQueryError = AxiosError<null>;

export function useGetControlResultsInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getControlResults>>,
        GetControlResultsParams["cursor"]
    >,
    TError = AxiosError<null>,
>(
    params: undefined | GetControlResultsParams,
    options: {
        query: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getControlResults>>,
                QueryKey,
                GetControlResultsParams["cursor"]
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlResults>>,
                    TError,
                    Awaited<ReturnType<typeof getControlResults>>,
                    QueryKey
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlResultsInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getControlResults>>,
        GetControlResultsParams["cursor"]
    >,
    TError = AxiosError<null>,
>(
    params?: GetControlResultsParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getControlResults>>,
                QueryKey,
                GetControlResultsParams["cursor"]
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlResults>>,
                    TError,
                    Awaited<ReturnType<typeof getControlResults>>,
                    QueryKey
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlResultsInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getControlResults>>,
        GetControlResultsParams["cursor"]
    >,
    TError = AxiosError<null>,
>(
    params?: GetControlResultsParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getControlResults>>,
                QueryKey,
                GetControlResultsParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlResultsInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getControlResults>>,
        GetControlResultsParams["cursor"]
    >,
    TError = AxiosError<null>,
>(
    params?: GetControlResultsParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getControlResults>>,
                QueryKey,
                GetControlResultsParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlResultsInfiniteQueryOptions(
        params,
        options
    );

    const query = useInfiniteQuery(
        queryOptions,
        queryClient
    ) as UseInfiniteQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlResultsQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetControlResultsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetControlResultsQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlResults>>
    > = ({ signal }) => getControlResults(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getControlResults>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlResultsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlResults>>
>;
export type GetControlResultsQueryError = AxiosError<null>;

export function useGetControlResults<
    TData = Awaited<ReturnType<typeof getControlResults>>,
    TError = AxiosError<null>,
>(
    params: undefined | GetControlResultsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlResults>>,
                    TError,
                    Awaited<ReturnType<typeof getControlResults>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlResults<
    TData = Awaited<ReturnType<typeof getControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetControlResultsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlResults>>,
                    TError,
                    Awaited<ReturnType<typeof getControlResults>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlResults<
    TData = Awaited<ReturnType<typeof getControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetControlResultsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlResults<
    TData = Awaited<ReturnType<typeof getControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetControlResultsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlResultsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlResultsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetControlResultsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetControlResultsQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlResults>>
    > = ({ signal }) => getControlResults(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getControlResults>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlResultsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlResults>>
>;
export type GetControlResultsSuspenseQueryError = AxiosError<null>;

export function useGetControlResultsSuspense<
    TData = Awaited<ReturnType<typeof getControlResults>>,
    TError = AxiosError<null>,
>(
    params: undefined | GetControlResultsParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlResultsSuspense<
    TData = Awaited<ReturnType<typeof getControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetControlResultsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlResultsSuspense<
    TData = Awaited<ReturnType<typeof getControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetControlResultsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlResultsSuspense<
    TData = Awaited<ReturnType<typeof getControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetControlResultsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlResultsSuspenseQueryOptions(
        params,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postControlResultsArchive = (
    bulkArchiveControlResultsData: BulkArchiveControlResultsData,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(
        `/api/control-results/archive`,
        bulkArchiveControlResultsData,
        options
    );
};

export const getPostControlResultsArchiveMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlResultsArchive>>,
        TError,
        { data: BulkArchiveControlResultsData },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlResultsArchive>>,
    TError,
    { data: BulkArchiveControlResultsData },
    TContext
> => {
    const mutationKey = ["postControlResultsArchive"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlResultsArchive>>,
        { data: BulkArchiveControlResultsData }
    > = (props) => {
        const { data } = props ?? {};

        return postControlResultsArchive(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlResultsArchiveMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlResultsArchive>>
>;
export type PostControlResultsArchiveMutationBody =
    BulkArchiveControlResultsData;
export type PostControlResultsArchiveMutationError = AxiosError<unknown>;

export const usePostControlResultsArchive = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlResultsArchive>>,
            TError,
            { data: BulkArchiveControlResultsData },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlResultsArchive>>,
    TError,
    { data: BulkArchiveControlResultsData },
    TContext
> => {
    return useMutation(
        getPostControlResultsArchiveMutationOptions(options),
        queryClient
    );
};
export const postControlResultsUnarchive = (
    bulkUnarchiveControlResultsData: BulkUnarchiveControlResultsData,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(
        `/api/control-results/unarchive`,
        bulkUnarchiveControlResultsData,
        options
    );
};

export const getPostControlResultsUnarchiveMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlResultsUnarchive>>,
        TError,
        { data: BulkUnarchiveControlResultsData },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlResultsUnarchive>>,
    TError,
    { data: BulkUnarchiveControlResultsData },
    TContext
> => {
    const mutationKey = ["postControlResultsUnarchive"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlResultsUnarchive>>,
        { data: BulkUnarchiveControlResultsData }
    > = (props) => {
        const { data } = props ?? {};

        return postControlResultsUnarchive(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlResultsUnarchiveMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlResultsUnarchive>>
>;
export type PostControlResultsUnarchiveMutationBody =
    BulkUnarchiveControlResultsData;
export type PostControlResultsUnarchiveMutationError = AxiosError<unknown>;

export const usePostControlResultsUnarchive = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlResultsUnarchive>>,
            TError,
            { data: BulkUnarchiveControlResultsData },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlResultsUnarchive>>,
    TError,
    { data: BulkUnarchiveControlResultsData },
    TContext
> => {
    return useMutation(
        getPostControlResultsUnarchiveMutationOptions(options),
        queryClient
    );
};
export const postControlResultsExport = (
    exportControlResultsParams: ExportControlResultsParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<Blob>> => {
    return axios.post(
        `/api/control-results/export`,
        exportControlResultsParams,
        {
            responseType: "blob",
            paramsSerializer: { indexes: null },
            ...options,
        }
    );
};

export const getPostControlResultsExportMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlResultsExport>>,
        TError,
        { data: ExportControlResultsParams },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlResultsExport>>,
    TError,
    { data: ExportControlResultsParams },
    TContext
> => {
    const mutationKey = ["postControlResultsExport"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlResultsExport>>,
        { data: ExportControlResultsParams }
    > = (props) => {
        const { data } = props ?? {};

        return postControlResultsExport(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlResultsExportMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlResultsExport>>
>;
export type PostControlResultsExportMutationBody = ExportControlResultsParams;
export type PostControlResultsExportMutationError = AxiosError<null>;

export const usePostControlResultsExport = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlResultsExport>>,
            TError,
            { data: ExportControlResultsParams },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlResultsExport>>,
    TError,
    { data: ExportControlResultsParams },
    TContext
> => {
    return useMutation(
        getPostControlResultsExportMutationOptions(options),
        queryClient
    );
};
export const postControlResultsExtendDueDate = (
    extendControlResultsDueDateData: ExtendControlResultsDueDateData,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(
        `/api/control-results/extend-due-date`,
        extendControlResultsDueDateData,
        options
    );
};

export const getPostControlResultsExtendDueDateMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlResultsExtendDueDate>>,
        TError,
        { data: ExtendControlResultsDueDateData },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlResultsExtendDueDate>>,
    TError,
    { data: ExtendControlResultsDueDateData },
    TContext
> => {
    const mutationKey = ["postControlResultsExtendDueDate"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlResultsExtendDueDate>>,
        { data: ExtendControlResultsDueDateData }
    > = (props) => {
        const { data } = props ?? {};

        return postControlResultsExtendDueDate(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlResultsExtendDueDateMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlResultsExtendDueDate>>
>;
export type PostControlResultsExtendDueDateMutationBody =
    ExtendControlResultsDueDateData;
export type PostControlResultsExtendDueDateMutationError = AxiosError<unknown>;

export const usePostControlResultsExtendDueDate = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlResultsExtendDueDate>>,
            TError,
            { data: ExtendControlResultsDueDateData },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlResultsExtendDueDate>>,
    TError,
    { data: ExtendControlResultsDueDateData },
    TContext
> => {
    return useMutation(
        getPostControlResultsExtendDueDateMutationOptions(options),
        queryClient
    );
};
export const postControlResultsReassign = (
    reassignIds: ReassignIds,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(`/api/control-results/reassign`, reassignIds, options);
};

export const getPostControlResultsReassignMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlResultsReassign>>,
        TError,
        { data: ReassignIds },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlResultsReassign>>,
    TError,
    { data: ReassignIds },
    TContext
> => {
    const mutationKey = ["postControlResultsReassign"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlResultsReassign>>,
        { data: ReassignIds }
    > = (props) => {
        const { data } = props ?? {};

        return postControlResultsReassign(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlResultsReassignMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlResultsReassign>>
>;
export type PostControlResultsReassignMutationBody = ReassignIds;
export type PostControlResultsReassignMutationError = AxiosError<unknown>;

export const usePostControlResultsReassign = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlResultsReassign>>,
            TError,
            { data: ReassignIds },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlResultsReassign>>,
    TError,
    { data: ReassignIds },
    TContext
> => {
    return useMutation(
        getPostControlResultsReassignMutationOptions(options),
        queryClient
    );
};
export const postControlResultsRemind = (
    remindIds: RemindIds,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(`/api/control-results/remind`, remindIds, options);
};

export const getPostControlResultsRemindMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlResultsRemind>>,
        TError,
        { data: RemindIds },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlResultsRemind>>,
    TError,
    { data: RemindIds },
    TContext
> => {
    const mutationKey = ["postControlResultsRemind"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlResultsRemind>>,
        { data: RemindIds }
    > = (props) => {
        const { data } = props ?? {};

        return postControlResultsRemind(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlResultsRemindMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlResultsRemind>>
>;
export type PostControlResultsRemindMutationBody = RemindIds;
export type PostControlResultsRemindMutationError = AxiosError<unknown>;

export const usePostControlResultsRemind = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlResultsRemind>>,
            TError,
            { data: RemindIds },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlResultsRemind>>,
    TError,
    { data: RemindIds },
    TContext
> => {
    return useMutation(
        getPostControlResultsRemindMutationOptions(options),
        queryClient
    );
};
export const postControlResultsReopen = (
    reopenIds: ReopenIds,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(`/api/control-results/reopen`, reopenIds, options);
};

export const getPostControlResultsReopenMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlResultsReopen>>,
        TError,
        { data: ReopenIds },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlResultsReopen>>,
    TError,
    { data: ReopenIds },
    TContext
> => {
    const mutationKey = ["postControlResultsReopen"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlResultsReopen>>,
        { data: ReopenIds }
    > = (props) => {
        const { data } = props ?? {};

        return postControlResultsReopen(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlResultsReopenMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlResultsReopen>>
>;
export type PostControlResultsReopenMutationBody = ReopenIds;
export type PostControlResultsReopenMutationError = AxiosError<unknown>;

export const usePostControlResultsReopen = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlResultsReopen>>,
            TError,
            { data: ReopenIds },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlResultsReopen>>,
    TError,
    { data: ReopenIds },
    TContext
> => {
    return useMutation(
        getPostControlResultsReopenMutationOptions(options),
        queryClient
    );
};
export const postControlResultsDownloadAttachments = (
    bulkDownloadControlResultAttachmentsParams: BulkDownloadControlResultAttachmentsParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<Blob>> => {
    return axios.post(
        `/api/control-results/download-attachments`,
        bulkDownloadControlResultAttachmentsParams,
        {
            responseType: "blob",
            paramsSerializer: { indexes: null },
            ...options,
        }
    );
};

export const getPostControlResultsDownloadAttachmentsMutationOptions = <
    TError = AxiosError<BulkDownloadControlResultAttachmentsErrorPayload>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlResultsDownloadAttachments>>,
        TError,
        { data: BulkDownloadControlResultAttachmentsParams },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlResultsDownloadAttachments>>,
    TError,
    { data: BulkDownloadControlResultAttachmentsParams },
    TContext
> => {
    const mutationKey = ["postControlResultsDownloadAttachments"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlResultsDownloadAttachments>>,
        { data: BulkDownloadControlResultAttachmentsParams }
    > = (props) => {
        const { data } = props ?? {};

        return postControlResultsDownloadAttachments(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlResultsDownloadAttachmentsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlResultsDownloadAttachments>>
>;
export type PostControlResultsDownloadAttachmentsMutationBody =
    BulkDownloadControlResultAttachmentsParams;
export type PostControlResultsDownloadAttachmentsMutationError =
    AxiosError<BulkDownloadControlResultAttachmentsErrorPayload>;

export const usePostControlResultsDownloadAttachments = <
    TError = AxiosError<BulkDownloadControlResultAttachmentsErrorPayload>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlResultsDownloadAttachments>>,
            TError,
            { data: BulkDownloadControlResultAttachmentsParams },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlResultsDownloadAttachments>>,
    TError,
    { data: BulkDownloadControlResultAttachmentsParams },
    TContext
> => {
    return useMutation(
        getPostControlResultsDownloadAttachmentsMutationOptions(options),
        queryClient
    );
};
export const getFutureControlResults = (
    params?: GetFutureControlResultsParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<FutureControlResultPaginatedListDto>> => {
    return axios.get(`/api/future-control-results`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetFutureControlResultsInfiniteQueryKey = (
    params?: GetFutureControlResultsParams
) => {
    return [
        "infinite",
        `/api/future-control-results`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetFutureControlResultsQueryKey = (
    params?: GetFutureControlResultsParams
) => {
    return [
        `/api/future-control-results`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetFutureControlResultsInfiniteQueryOptions = <
    TData = InfiniteData<
        Awaited<ReturnType<typeof getFutureControlResults>>,
        GetFutureControlResultsParams["cursor"]
    >,
    TError = AxiosError<null>,
>(
    params?: GetFutureControlResultsParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getFutureControlResults>>,
                QueryKey,
                GetFutureControlResultsParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetFutureControlResultsInfiniteQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getFutureControlResults>>,
        QueryKey,
        GetFutureControlResultsParams["cursor"]
    > = ({ signal, pageParam }) =>
        getFutureControlResults(
            { ...params, cursor: pageParam ?? params?.["cursor"] },
            { signal, ...axiosOptions }
        );

    return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getFutureControlResults>>,
        TError,
        TData,
        Awaited<ReturnType<typeof getFutureControlResults>>,
        QueryKey,
        GetFutureControlResultsParams["cursor"]
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFutureControlResultsInfiniteQueryResult = NonNullable<
    Awaited<ReturnType<typeof getFutureControlResults>>
>;
export type GetFutureControlResultsInfiniteQueryError = AxiosError<null>;

export function useGetFutureControlResultsInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getFutureControlResults>>,
        GetFutureControlResultsParams["cursor"]
    >,
    TError = AxiosError<null>,
>(
    params: undefined | GetFutureControlResultsParams,
    options: {
        query: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getFutureControlResults>>,
                QueryKey,
                GetFutureControlResultsParams["cursor"]
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getFutureControlResults>>,
                    TError,
                    Awaited<ReturnType<typeof getFutureControlResults>>,
                    QueryKey
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFutureControlResultsInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getFutureControlResults>>,
        GetFutureControlResultsParams["cursor"]
    >,
    TError = AxiosError<null>,
>(
    params?: GetFutureControlResultsParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getFutureControlResults>>,
                QueryKey,
                GetFutureControlResultsParams["cursor"]
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getFutureControlResults>>,
                    TError,
                    Awaited<ReturnType<typeof getFutureControlResults>>,
                    QueryKey
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFutureControlResultsInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getFutureControlResults>>,
        GetFutureControlResultsParams["cursor"]
    >,
    TError = AxiosError<null>,
>(
    params?: GetFutureControlResultsParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getFutureControlResults>>,
                QueryKey,
                GetFutureControlResultsParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetFutureControlResultsInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getFutureControlResults>>,
        GetFutureControlResultsParams["cursor"]
    >,
    TError = AxiosError<null>,
>(
    params?: GetFutureControlResultsParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getFutureControlResults>>,
                QueryKey,
                GetFutureControlResultsParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetFutureControlResultsInfiniteQueryOptions(
        params,
        options
    );

    const query = useInfiniteQuery(
        queryOptions,
        queryClient
    ) as UseInfiniteQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetFutureControlResultsQueryOptions = <
    TData = Awaited<ReturnType<typeof getFutureControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetFutureControlResultsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetFutureControlResultsQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getFutureControlResults>>
    > = ({ signal }) =>
        getFutureControlResults(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getFutureControlResults>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFutureControlResultsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getFutureControlResults>>
>;
export type GetFutureControlResultsQueryError = AxiosError<null>;

export function useGetFutureControlResults<
    TData = Awaited<ReturnType<typeof getFutureControlResults>>,
    TError = AxiosError<null>,
>(
    params: undefined | GetFutureControlResultsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getFutureControlResults>>,
                    TError,
                    Awaited<ReturnType<typeof getFutureControlResults>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFutureControlResults<
    TData = Awaited<ReturnType<typeof getFutureControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetFutureControlResultsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getFutureControlResults>>,
                    TError,
                    Awaited<ReturnType<typeof getFutureControlResults>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFutureControlResults<
    TData = Awaited<ReturnType<typeof getFutureControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetFutureControlResultsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetFutureControlResults<
    TData = Awaited<ReturnType<typeof getFutureControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetFutureControlResultsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetFutureControlResultsQueryOptions(
        params,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetFutureControlResultsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getFutureControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetFutureControlResultsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetFutureControlResultsQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getFutureControlResults>>
    > = ({ signal }) =>
        getFutureControlResults(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getFutureControlResults>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFutureControlResultsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getFutureControlResults>>
>;
export type GetFutureControlResultsSuspenseQueryError = AxiosError<null>;

export function useGetFutureControlResultsSuspense<
    TData = Awaited<ReturnType<typeof getFutureControlResults>>,
    TError = AxiosError<null>,
>(
    params: undefined | GetFutureControlResultsParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFutureControlResultsSuspense<
    TData = Awaited<ReturnType<typeof getFutureControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetFutureControlResultsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFutureControlResultsSuspense<
    TData = Awaited<ReturnType<typeof getFutureControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetFutureControlResultsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetFutureControlResultsSuspense<
    TData = Awaited<ReturnType<typeof getFutureControlResults>>,
    TError = AxiosError<null>,
>(
    params?: GetFutureControlResultsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getFutureControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetFutureControlResultsSuspenseQueryOptions(
        params,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
